import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { BillingState } from './billing-state';


export class BillingStateService  {
	public readonly _state = new BehaviorSubject<BillingState>({
		actionInProgress: false,
		isMasterAccount: false
	});
	public readonly state$ = this._state.asObservable().map((state) => Object.assign({}, state));

	public get state(): BillingState {
		return {...this._state.getValue()};
	}

	public set state(state: BillingState) {
		this._state.next(state);
	}

	public setActionInProgress(value) {
		this.state = {
			...this.state,
			actionInProgress: value
		};
	}

	public setIsMasterAccount(value) {
		this.state = {
			...this.state,
			isMasterAccount: value
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/billing/store/billing-state.service.ts